import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const LostUpdateConcurrency = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Concurrent Transactions – Lost Update Problem"
    videos={[
      "https://www.youtube.com/embed/C_J6K8DodS8?si=oLqYKUz24FVI9Nad",
      "https://www.youtube.com/embed/oP8yLMjmszE?si=Tos5GZ_UF_IfM7Sj"
    ]}
    takeaways={[]}
    questions={[
      "1) Identify and justify how the following concurrency control problems affect data integrity and consistency in a multi-user environment. S1: r1(x); r2(x); w1(x); r3(x); w2(x); c2; r4(x); w3(x); c3; w1(y); c1; S2: r1(x); w1(x); r2(x); w2(x); c2; r3(x); c3; w1(y); c1; S3: r1(x); w1(x); r2(x); w2(x); r1(x);"
    ]}
    exampleVideos={[]}
  />
);
}

export default LostUpdateConcurrency;
